import styled from 'styled-components';

import { CARD_RADIUS, PAGE_MAX_WIDTH } from '../styles/constants';

export default styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  height: 100%;
  width: 100%;
  max-width: ${PAGE_MAX_WIDTH};
  margin: -24px auto 0 auto;

  background-color: ${(p) => p.theme.pageBackgroundColor};
  border-radius: ${CARD_RADIUS} ${CARD_RADIUS} 0 0;

  > div:nth-child(2) {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
`;
